// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"688db299","290":"1c37c765","418":"cd7544ad","828":"fe76edcc","937":"394b863c"}[chunkId] + ".chunk.css";
};